export const countBy = (arr, by) => arr.reduce((acc, a) => {
    var _a;
    const key = by(a);
    acc[key] = ((_a = acc[key]) !== null && _a !== void 0 ? _a : 0) + 1;
    return acc;
}, {});
